import gsap from "../libs/gsap.min";
import ScrollTrigger from "../libs/ScrollTrigger.min";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({limitCallbacks: true});

let pipelinePhases = document.querySelectorAll('.shortcode-pipeline-bar');

gsap.utils.toArray(pipelinePhases).forEach(pipeline => {
    let startAnimation = () => {
            pipeline.classList.add('animate');
            st && st.kill();
        },
        st = ScrollTrigger.create({
            trigger: pipeline,
            start: "-20% bottom",
            onEnter: startAnimation,
            onEnterBack: startAnimation,
            once: true,
        });
});